import DigitalTwinMap from "../../components/digitalTwin/map/digitalTwinmap.component";
import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { clearDTField } from "../../store/features/digitalTwin/selectedDigitalTwinSlice";

/* Home of Digital Twin platform */
/* The home shows a map and a side bar with */
const DigitalTwinPage = () => {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(clearDTField());
  }, [dispatch]);

  return <DigitalTwinMap />;
};

export default DigitalTwinPage;
